// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import http from './js/http.js' //axios实例化后引入取名http
import pages from './components/Pages'
import pagesOther from './components/PagesOther'
import headerAll from './components/headerAll'
import Navbar from "@/components/Navbar.vue";

import './directives.js'
import './assets/css/common.less' /*引入公共样式*/
import store from './store'

import Echarts from 'echarts'
import 'echarts/map/js/china'
import axios from 'axios'
import qs from 'qs'
import scroll from 'vue-seamless-scroll' // 无缝滚动插件
import './font/font.css'
import {getDict, getDictList} from '@/js/getDict'
import App from './App'
import router from './router'
// 复制插件
import VueClipboard from 'vue-clipboard2'

Vue.prototype.bus = new Vue()
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
Vue.prototype.qs = qs           //全局注册，使用方法为:this.qs
Vue.prototype.$echarts = Echarts
Vue.use(Echarts)
Vue.use(store)
Vue.use(scroll)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.http = http;  //放入全局
Vue.use(VueClipboard) //复制插件
Vue.component('pages', pages)
Vue.component('pagesOther', pagesOther)
Vue.component('headerAll', headerAll)
Vue.component('Navbar', Navbar)
Vue.prototype.$getDict = getDict
Vue.prototype.$getDictList = getDictList
// 全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    clearTimer()
  } else {
    // 在这里设置定时器
    // setTimer()
  }
  // 调用 next() 表示继续执行下一个守卫或路由
  next()
})

// 在刷新时清除定时器
window.addEventListener('beforeunload', () => {
  clearTimer()
})

// 定义全局变量来存储定时器
let timer = null

// 设置定时器的函数
function setTimer() {
  // 每隔一段时间执行一次你的逻辑
  timer = setInterval(() => {
    // 这里写你的定时器逻辑
    console.log('定时器执行中...')
    let success = (res) => {
    }
    http.get("/wxf/alarmSingle/status", '', success);
  }, 5000) // 10秒执行一次，你可以根据需求修改时间间隔
}

// 清除定时器的函数
function clearTimer() {
  if (timer) {
    console.log('定时器关闭...')
    clearInterval(timer)
    timer = null
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,  //这里配置后所有的组件对象多了个属性: $store
  components: { App },
  template: '<App/>',
  data () {
    return {
      eventHub: new Vue()
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js